import {
    AtualizarEquipeService,
    CadastrarEquipeService,
    DeletarEquipeService,
    GetEquipeService,
    GetEquipeUsuarioService,
    ListarEquipesServices,
} from "../../../Services/HelpDesk/Equipes/EquipesServices";

import {
    ICadastroEquipe,
    IEquipe,
} from "../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import { Controller } from "../../Controller";

export async function ListarEquipesController() {
    return Controller(ListarEquipesServices());
}

export async function AtualizarEquipeController(requestBody: IEquipe) {
    return Controller(AtualizarEquipeService(requestBody));
}

export async function DeletarEquipeController(ID_FILA: number) {
    return Controller(DeletarEquipeService(ID_FILA));
}

export async function CadastrarEquipeController(requestBody: ICadastroEquipe) {
    return Controller(CadastrarEquipeService(requestBody));
}

export async function GetEquipeController(ID_FILA: number) {
    return Controller(GetEquipeService(ID_FILA));
}

export async function GetEquipeUsuarioController() {
    return Controller(GetEquipeUsuarioService());
}
